import {BOARD_ID} from '@/util/BoardConst';

const MY_BID = {
  NOTICE: BOARD_ID.BID_MAIN_NOICE,
  POPUP: BOARD_ID.BID_MAIN_POPUP,
};

export default MY_BID;
